<template>
    <div class="form-set-control-wrap">
        <div class="form-set-control-top">
            <div class="form-set-control-top_return">
                <span class="back-icon" @click="handleClickReturn"><i class="el-icon-arrow-left"></i>返回</span>
                <span class="back-title">{{ formTitle }}</span>
            </div>
            <div class="form-set-control-top_right">
                <el-button plain size="small" type="primary" @click="handleClickCustomFormReview">预览</el-button>
                <el-button size="small" type="primary" @click="handleClickCustomFormPublish">发布</el-button>
            </div>
        </div>
        <div class="form-set-control-content">
            <CustomFormSite
                ref="customFormSite"
                :can_set_show_rules="true"
                :field_form="fieldForm"
                :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置'"
                :field_form_title="'表单预览区'"
                :is_form_module="false"
                :is_two_column="true"
                :publish_btn_show="false"
                :review_btn_show="false"
                :review_form_type_list="reviewFormTypeList"
                @submit-fields="submitFields"
            />
        </div>
        <FormTplSelect
            v-if="formTplDialog"
            :formTplDialog.sync="formTplDialog"
            :formTplTitle="'表单模版'"
            :formTplDesc="formTplDesc"
            :formTplList="formTplList"
            :field_form="fieldForm"
            :field_form_title="'新增客户'"
            :formTplPreviewDesc="formTplPreviewDesc"
        />
    </div>
</template>
<script>
import CustomFormSite from "@/components/pComponents/CustomFormSite";
import FormTplSelect from "@/components/pComponents/FormTplSelect.vue";
import { saveFormFields } from "@/api";

export default {
    name: "customerFormSet",
    components: { CustomFormSite, FormTplSelect },
    data() {
        return {
            fieldForm: this.$route.query.type,
            formTplDialog: false,
            formTplDesc: "您可以选择以下模版，帮助您快速配置字段，使用后也可以自定义修改内容或添加新字段",
            formTplList: [
                {
                    type: 1,
                    title: "模版一",
                    desc: "注重对客户公司信息的全方位了解及记录",
                    secTitle: "新增客户",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/ddcc8b43a75d4e32dc9b6c8a28d8d4df.png",
                },
                {
                    type: 2,
                    title: "模版二",
                    desc: "注重对客户公司的合作意向、阶段等情况的记录及分析",
                    secTitle: "新增客户",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/1ea016a16456ccc881b5c499e8a56720.png",
                },
                {
                    type: 3,
                    title: "模版三",
                    desc: "前两个模版的合集，可以对客户公司各角度的管理",
                    secTitle: "新增客户",
                    thumbnail: "https://download.hecoos.com/enlightv/2024-47/c4301a89c8094fa91460a6e38f32b1f6.png",
                },
            ],
            formTplPreviewDesc:
                "模拟真实新增客户页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
            fieldsData: {},
            submitFlag: false,
            reviewFormTypeList: [
                {
                    title: "新增客户电脑端",
                    value: "pc",
                    form_title: "新增客户",
                    form_desc:
                        "模拟真实新增客户页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
                {
                    title: "新增客户移动端",
                    value: "mobile",
                    form_title: "新增客户",
                    form_desc:
                        "模拟真实新增客户页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
            ],
            formInfoList: [],
        };
    },
    computed: {
        formTitle() {
            const type = this.fieldForm;
            let formTitle = "";
            switch (type) {
                case "customer_contacts":
                    formTitle = "联系人";
                    break;
                case "customer_follow_ups":
                    formTitle = "跟进记录";
                    break;
                case "customer_management":
                    formTitle = "管理记录";
                    break;
                default:
                    formTitle = "客户信息";
                    break;
            }
            return formTitle;
        },
    },
    created() {
        if (this.fieldForm == "customers") {
            this.formTplDialog = true;
        }
    },
    methods: {
        handleClickReturn() {
            this.$router.go(-1);
        },

        submitFields(data) {
            this.submitFlag = false;
            if (data && data.field_list) {
                this.submitFlag = true;
            }
            this.fieldsData = data;
        },

        handleClickCustomFormReview() {
            this.$refs.customFormSite.handleClickReview();
        },

        handleClickCustomFormPublish() {
            this.$refs.customFormSite.handleClickPublish();
            if (this.submitFlag) {
                this.$refs.customFormSite.btnDisabled = true;
                saveFormFields(this.fieldsData).then((res) => {
                    if (res.code === 200) {
                        this.$message.success("设置成功");
                    } else {
                        this.$message.error(res.message);
                    }
                    this.$refs.customFormSite.btnDisabled = false;
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>

</style>
